'use client'

import { DownloadSquare01Icon } from '@hugeicons-pro/core-solid-rounded'
import _ from 'lodash'
import { LoaderCircle } from 'lucide-react'

import { HugeiconsIcon } from '@hugeicons/react'

import { LevelFooter } from '../Footer'
import { HUD } from '../HUD'
import { LevelToolbar } from '../Toolbar'

import { useLevelContext } from '@/features/level-play'
import { ChallengeStep, useFlow } from '@/shared/lib/steps-flow'
import { showErrorAlert } from '@/shared/lib/ui'
import { Button } from '@/shared/ui/Button'

interface GameFileProps {
  step: ChallengeStep
  challengeId: number
}

export function GameFile({ challengeId }: GameFileProps) {
  const { goNext, enableContinue, verifyChallenge } = useFlow()
  const { level, isSubmitting, onChallengeAnswer, getMinimumAdvanceStatus } =
    useLevelContext()

  const challenge = level?.active_challenges.find(c => c.id === challengeId)
  const minimumAdvance = getMinimumAdvanceStatus(challengeId)
  const { meta } = challenge
  const fileUrl = _.get(meta, 'file.file.url')

  const handleDownload = () => {
    window.open(fileUrl, '_blank')
  }

  const handleContinue = async () => {
    if (!challenge) return

    try {
      const { ok } = await onChallengeAnswer({
        uid: challenge.uid,
        answer: 'Arquivo baixado',
        skipValidation: true
      })

      if (ok) enableContinue()
      verifyChallenge({ correct: true })
      goNext()
    } catch (error) {
      showErrorAlert(error)
    }
  }

  return (
    <HUD.Card>
      <HUD.Header challenge={challenge} />
      <HUD.Toolbar>
        <LevelToolbar />
      </HUD.Toolbar>
      <HUD.Body className="flex flex-col gap-4">
        <HUD.Description challenge={challenge} />

        <div
          className="w-full h-200px bg-light rounded-2 border-2 border-primary rounded-2 flex flex-col items-center justify-center cursor-pointer bg-light-info gap-4"
          onClick={handleDownload}
        >
          <HugeiconsIcon
            icon={DownloadSquare01Icon}
            size={50}
            className="text-info"
          />
          <span className="font-bold text-dark fs-5">Clique para baixar</span>
        </div>
      </HUD.Body>

      <LevelFooter>
        <Button
          type="button"
          onClick={handleContinue}
          className="w-full font-bold btn btn-info"
          disabled={minimumAdvance.isLocked || isSubmitting}
        >
          {isSubmitting ? (
            <>
              <LoaderCircle className="size-5 animate-spin" />
              <span>Carregando</span>
            </>
          ) : (
            <span>
              {minimumAdvance.isLocked
                ? `Aguarde ${minimumAdvance.label}`
                : 'Continuar'}
            </span>
          )}
        </Button>
      </LevelFooter>
    </HUD.Card>
  )
}
